import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmbed = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_4467_146137)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M10 8.84315V14.5M10 14.5H15.5M10 14.5L18.364 6.13604M13.7568 3.67216C10.9096 3.10828 7.84251 3.92957 5.63604 6.13604C2.12132 9.65076 2.12132 15.3492 5.63604 18.864C9.15076 22.3787 14.8492 22.3787 18.364 18.864C20.5704 16.6575 21.3917 13.5904 20.8278 10.7432",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4467_146137",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M0 4.5C0 2.29086 1.79086 0.5 4 0.5H20C22.2091 0.5 24 2.29086 24 4.5V20.5C24 22.7091 22.2091 24.5 20 24.5H4C1.79086 24.5 0 22.7091 0 20.5V4.5Z",
			fill: "currentColor"
		})
	}) })]
});
export default SvgEmbed;
